import React from 'react';

/**
 * DemoWatermark Component
 *
 * Displays a "MOCK-UP" watermark overlay on demo group pages.
 * Styled in OurNet's mauve color at low opacity, rotated diagonally.
 *
 * Usage:
 *   {showDemoWatermark && <DemoWatermark />}   (App.js / MainFeed — demo mode, Phase B1)
 */
const DemoWatermark = () => {
  // Allow hiding watermark via ?watermark=off for recording sessions
  const params = new URLSearchParams(window.location.search);
  if (params.get('watermark') === 'off') return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%) rotate(-45deg)',
        fontSize: '140px',
        fontWeight: 'bold',
        color: '#BB4D9A', // OurNet mauve
        opacity: 0.15,
        pointerEvents: 'none',
        userSelect: 'none',
        zIndex: 1000,
        whiteSpace: 'nowrap',
        letterSpacing: '0.15em',
        fontFamily: 'OpenSauceSans, sans-serif',
        textTransform: 'uppercase'
      }}
    >
      MOCK-UP
    </div>
  );
};

export default DemoWatermark;
